<modal [name]="localStorageKeys.ti_modal_errors_information" (closeOut)="onClose()" [width]="'90%'" [height]="'90%'">
  <modal-header>
    <span>{{ strings.errorsInformation }}</span>
  </modal-header>
  <modal-body>
    <kendo-splitter orientation="horizontal">
      <kendo-splitter-pane size="20%" [collapsible]="true">
        <kendo-treeview
          [nodes]="treeData"
          textField="text"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          kendoTreeViewHierarchyBinding
          childrenField="items"
          [expandBy]="'id'"
          [(expandedKeys)]="expandedKeys"
          [(selectedKeys)]="selectedKeys"
          (selectionChange)="handleTreeSelection($event)"
        >
          <ng-template kendoTreeViewNodeTemplate let-dataItem>
            <div class="tree-node">
              <div class="tree-node-main">
                <span class="tree-node-icon" [ngClass]="getIconClass(dataItem)"></span>
                <span>{{dataItem.text}}</span>
              </div>
              <div class="tree-node-additional-text">{{dataItem.quantity}}</div>
            </div>
          </ng-template>
        </kendo-treeview>
      </kendo-splitter-pane>

      <kendo-splitter-pane>
        <div class="errors-quantity">{{quantity}} {{strings.errors}}</div>
        <kendo-grid [data]="gridData" [resizable]="true" [reorderable]="true">
          <kendo-grid-column field="ErrorSeverity" [title]="strings.typeColumn" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span *ngIf="dataItem.ErrorSeverity === ErrorSeverity.Major" class="error-severity-critical">{{strings.critical}}</span>
              <span *ngIf="dataItem.ErrorSeverity === ErrorSeverity.Minor" class="error-severity-minor">{{strings.minor}}</span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="ErrorCode" [title]="strings.errorCodeColumn" [width]="65"></kendo-grid-column>
          <kendo-grid-column field="ErrorMessage" [title]="strings.errorMessageColumn" [width]="245"></kendo-grid-column>
          <kendo-grid-column field="ObjectName" [title]="strings.objectNameColumn" [width]="120"></kendo-grid-column>
          <kendo-grid-column field="ErrorGroup" [title]="strings.errorGroupColumn" [width]="180"></kendo-grid-column>
        </kendo-grid>
      </kendo-splitter-pane>
    </kendo-splitter>

    <div class="info-block">
      <span class="fa fa-info-circle" aria-hidden="true"></span>
      <div class="errors-hint-container" *ngIf="roomId; else createRoomHint">
        <div class="errors-hint">{{strings.errorsHint}}</div>
        <div class="errors-hint" [innerHTML]="strings.cancelErrorsHint"></div>
        <div class="errors-hint" [innerHTML]="strings.resetErrorsHint"></div>
      </div>
      <ng-template #createRoomHint>
        <div class="errors-hint-container">
          <div class="errors-hint">{{strings.errorsHint}}</div>
        </div>
      </ng-template>
    </div>

  </modal-body>
  <modal-actions *ngIf="roomId">
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="onClose()" [disabled]="isLoading">{{miscStrings.cancel}}</button>
    <button kendoButton (click)="onReset()" [primary]="true">{{strings.resetErrors}}</button>
  </modal-actions>
  <ti-spinner *ngIf="isLoading"></ti-spinner>
</modal>
